import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import dynamic from 'next/dynamic';
import ComponentsErrorBoundary from '@/components/ErrorBoundary/ComponentsErrorBoundary';
import LazyLoad from 'react-lazyload';
import { isEmpty } from 'lodash';
import styles from './index.module.less';
import PrimeButton from '../PrimeButton';

const ProductInfo = dynamic(import('../ProductInfo'));
const ProductSubmit = dynamic(import('../ProductSubmit'));
const ProductCounter = dynamic(import('../ProductCounter'));
const ProductPrice = dynamic(import('../ProductPrice'));
const ProductDiscount = dynamic(import('../ProductDiscount'));
const ProductAdapterType = dynamic(import('../ProductAdapterType'));
const VersionWrapper = dynamic(import('../VersionWrapper'));
const ProductIntro = dynamic(import('../ProductIntro'));
const ProductExtraTShirt = dynamic(
  import('@/components/activity/ActivityPages/2025TShirtGifts/components/ProductExtraTShirt')
);
const CustomSkin = dynamic(import('../CustomSkin'), { ssr: false });
const ProductExtraService = dynamic(import('../ProductExtraService'), { ssr: false });
const ShoppingList = dynamic(import('../ProductShoppingList'), { ssr: false });
const ProductFeatures = dynamic(import('../ProductFeatures'), { ssr: false });

@inject('area', 'product', 'order', 'app')
@observer
class TopInfo extends Component {
  render() {
    const { productDetail } = this.props.product;
    const { isNeedHidePrice } = productDetail;
    return (
      <div className={styles.wrapper}>
        {/* 产品信息 */}
        <ProductInfo />

        {/* 商品简介 */}
        <ProductIntro />

        {/* 产品页右边的详细信息展示：VB商品不显示价格，其余商品正常处理 */}
        {isNeedHidePrice ? (
          <ContactSalesModule />
        ) : (
          <ComponentsErrorBoundary name='ProductTopInfo'>
            <ProductTopInfoModule {...this.props} />
          </ComponentsErrorBoundary>
        )}
      </div>
    );
  }
}

// 商品TopInfo
const ProductTopInfoModule = observer((props) => {
  const { productDetail, curSelectCommodity, extraBindService } = props.product;
  const { InstaUserActive } = props.app;
  const { LANG } = props.area;
  const { is_camera } = productDetail;

  return (
    <div>
      {/* 营销模块折扣信息 */}
      <ProductDiscount />

      {/* 配件适配机型列表 */}
      <ProductAdapterType />

      {/* 套餐版本 */}
      <VersionWrapper />

      {/* 机身定制贴 */}
      <LazyLoad offset={400}>
        <CustomSkin />
      </LazyLoad>

      {/* 额外赠送T恤 */}
      {InstaUserActive ? (
        <ComponentsErrorBoundary name='TopInfo ProductExtraService TShirt'>
          <ProductExtraTShirt />
        </ComponentsErrorBoundary>
      ) : null}

      {/* 额外绑定服务 */}
      {InstaUserActive ? (
        <ComponentsErrorBoundary name='TopInfo ProductExtraService'>
          <ProductExtraService />
        </ComponentsErrorBoundary>
      ) : null}

      {/*
          当is_camera为true且当前套餐有绑定的增值服务套餐时则展示产品清单
          否则展示数量
        */}
      {productDetail?.is_camera && !isEmpty(extraBindService) ? (
        InstaUserActive ? (
          <ShoppingList />
        ) : null
      ) : (
        <ProductCounter />
      )}

      {/* !is_camera && 配件的价格、加购按钮直接展示在页面 */}
      {!is_camera && (
        <ComponentsErrorBoundary name='accessory productInfo'>
          <LazyLoad offset={400}>
            <ProductPrice />
            <ProductSubmit />
            {curSelectCommodity.isOutOfStock && (
              <span className={styles.outOfStock}>{LANG['productNew.outOfStock_tip']}</span>
            )}
            <ComponentsErrorBoundary name='pageTopInfo PrimeButton'>
              <PrimeButton from='productPage' />
            </ComponentsErrorBoundary>
          </LazyLoad>
        </ComponentsErrorBoundary>
      )}

      <ComponentsErrorBoundary name='ProductFeatures'>
        <LazyLoad offset={400}>
          <ProductFeatures />
        </LazyLoad>
      </ComponentsErrorBoundary>
    </div>
  );
});

// 不展示价格的商品，直接联系销售
function ContactSalesModule() {
  return <ProductSubmit />;
}

export default TopInfo;
